import { PASSCODE_ROUTES } from '../../../navigation/paths';

const AUTH_ENTRY_PATHS: ReadonlySet<string> = new Set(
  Object.values(PASSCODE_ROUTES).map((path) => path.toLowerCase()),
);

const isAuthEntryPath = (from: string): boolean => {
  const pathname = from.split(/[?#]/)[0].replace(/\/+$/, '').toLowerCase();
  return AUTH_ENTRY_PATHS.has(pathname);
};

export const returnPathOf = (state: unknown): string | null => {
  if (typeof state !== 'object' || state === null || !('from' in state)) return null;
  const from = (state as { from: unknown }).from;
  if (typeof from !== 'string') return null;
  if (!from.startsWith('/') || from.startsWith('//') || from.startsWith('/\\')) return null;
  if (isAuthEntryPath(from)) return null;
  return from;
};
